import { Pipe, PipeTransform } from '@angular/core';
import { DataObject } from '../interfaces';
import { MailerSettingLookup, MailerSettingLookupType } from '../interfaces/http/accounting/mailer-setting-lookup';
import {
  EmailTemplateLookup,
  EmailTemplateLookupType,
} from '../interfaces/http/invoice-settings/email-template-lookup';

@Pipe({
  name: 'groupTriggersByType',
  standalone: false, // eslint-disable-line
})
export class GroupTriggersByTypePipe implements PipeTransform {
  transform(triggers: DataObject<MailerSettingLookup>[]): {
    type: MailerSettingLookupType;
    triggers: DataObject<MailerSettingLookup>[];
  }[];
  transform(triggers: DataObject<EmailTemplateLookup>[]): {
    type: EmailTemplateLookupType;
    triggers: DataObject<EmailTemplateLookup>[];
  }[];
  transform(triggers: DataObject<MailerSettingLookup | EmailTemplateLookup>[]): {
    type: MailerSettingLookupType | EmailTemplateLookupType;
    triggers: DataObject<MailerSettingLookup | EmailTemplateLookup>[];
  }[] {
    if (!triggers) return [];
    const grouped = triggers.reduce((acc, trigger) => {
      const type = trigger.attributes.type;
      if (!acc[type]) {
        acc[type] = [];
      }
      acc[type].push(trigger);
      return acc;
    }, {});
    return Object.keys(grouped).map((key) => ({
      type: key as MailerSettingLookupType | EmailTemplateLookupType,
      triggers: grouped[key],
    }));
  }
}
